import React, {
  useState,
  useRef,
  useEffect,
} from 'react';
import { useQueries } from '@tanstack/react-query';
import { Link, useNavigate } from "react-router";

import { getBasketData} from "../queries/global";

import config from "../config/config";
import * as QUERIES from "../queries/query-functions";
import * as UTILS from "../utils/utils";

import InstanceEventSummary from '../components/instance-event-summary';
import InstanceBasketSummary from '../components/instance-basket-summary';
import ExtrasInstance from './extras-instance';
import BackButton from '../components/back-button';
import LoadingIndicator from '../components/loading-indicator';
import SeatSelectionSummary from '../book-online/seat-selection-summary';
import TicketInsurance from './ticket-insurance';
import Details from '../components/details';
import { useMediaQuery } from '../hook/useMediaQuery';


const advisory_message = config.OPTION_FIELDS.booking_advisory_message;

export default function Extras(props) {
    const navigate = useNavigate();

    const isMobile = useMediaQuery(`(max-width: 768px)`);
    const dialogRef = useRef(null);

    const { data: basketData } = getBasketData();

    const [groupedInstances, setGroupedInstances] = useState(null);
    const [instanceTickets, setInstanceTickets] = useState(null);
    const [isInBasket, setIsInBasket] = useState(false);


    useEffect(() => {
        if (!config.SUPPLEMENTARY_INSTANCES) {
            navigate("/basket", { replace: true });
        }
    }, []);

    const query_ids = config.SUPPLEMENTARY_INSTANCES;
    if (!config.SUPPLEMENTARY_INSTANCES) return;
    const query_map = query_ids?.map((instance_id) => ({
            queryKey: ['instance', instance_id],
            queryFn: () => QUERIES.getInstance(instance_id), 
            refetchOnWindowFocus: false
    }));

    const combinedExtras = useQueries({
        queries: query_map,
        combine: (results) => {
            return {
                data: results.map((result) => result.data),
                pending: results.some((result) => result.isPending),
            }
        },
    });


    useEffect(() => {
        if (!combinedExtras || !combinedExtras.data || combinedExtras.pending) return;

        let primary_instances = [];
        let secondary_instances = [];

        combinedExtras.data.forEach((instance) => {
            const eventName = instance.event?.name.toLowerCase(); 

            if (eventName.includes("refund")) {
                secondary_instances.push(instance);
            } else {
                primary_instances.push(instance);
            }
        });

        setGroupedInstances([
            {
                isProtection: true,
                title: "Ticket Refund Protection",
                instances: secondary_instances,
            },
            {
                isProtection: false,
                title: "Make your visit special",
                instances: primary_instances,
            },
        ]);

    }, [combinedExtras]);


    useEffect(() => {
        if (!basketData) return;

        let tickets = UTILS.getTicketsByInstance(basketData.tickets);
        setInstanceTickets(tickets);

        const supplementaryInBasket = basketData.tickets.some(ticket => (config.SUPPLEMENTARY_INSTANCES ?? []).includes(ticket.instance.id))
        setIsInBasket(supplementaryInBasket);

    }, [basketData])

    return (
        <div className='booking-pathway__container booking-pathway__extras'>
            <InstanceEventSummary  showAlternativeDates="true" />
            
            { !isMobile && <SeatSelectionSummary  setCheckedForPriority = {props.setCheckedForPriority}/> }
            
            <div className='booking-pathway__main-content'>
                {!combinedExtras.pending && groupedInstances ? 
                (
                    <>
                        <h1 className='booking-pathway__header'>Extras and upgrades</h1>
                        {groupedInstances.map((group) =>
                            group.instances.length ? (
                                <div key={group.title} className='extras-group'>
                                    {                                         
                                        group.isProtection ?
                                            group.instances.length && group.instances.map((instance) => (                                            
                                                <TicketInsurance  setIsInBasket={setIsInBasket} key={instance.id} instance={instance} instanceTickets={instanceTickets} sectionTitle={group.title}   />
                                            )) :

                                            group.instances.length && (
                                                <>
                                                    <h2 className='extras-group__title'>{group.title}</h2>
                                                    <div className='extras-group__extra'>
                                                        {
                                                            group.instances.map((instance) => (
                                                                <ExtrasInstance  setIsInBasket={setIsInBasket} key={instance.id} instance={instance} instanceTickets={instanceTickets} />
                                                            ))
                                                        }
                                                    </div>
                                                </>
                                            )
                                                                                 
                                    }
                                </div>
                            ) : null
                        )}
                    </>
                ) : 
                    <LoadingIndicator />
                }
            </div>

            { !isMobile && advisory_message && 
                <div class="booking-pathway__advisory-message"
                    dangerouslySetInnerHTML={{
                                __html:advisory_message.innerHTML,
                            }}
                ></div>
            }

            <div className='booking-pathway__footer'>
                <Link to="/basket" className={`btn ${isInBasket ? 'btn--primary' : ''}`}>{isInBasket ? "Continue to basket" : "Continue without extras"}</Link>
                
                { isMobile &&
                    <>
                        <button type="button" className="btn" onClick={()=>{dialogRef.current.showModal()}}>Show basket summary</button>
                        <dialog ref={dialogRef} className="basket-dialog">
                            <div className="dialog-container">
                                <div className="dialog-content">
                                    <SeatSelectionSummary setCheckedForPriority = {props.setCheckedForPriority}/>
                                    <div className="basket-dialog__footer">
                                        <div className="buttons">
                                            <Link to="/basket" className={`btn ${isInBasket ? 'btn--primary' : ''}`}>{isInBasket ? "Continue to basket" : "Continue without extras"}</Link>
                                            <button type="button" className="btn" onClick={()=>{dialogRef.current?.close()}}>Hide basket summary</button>                                      
                                        </div>
                                        { advisory_message && 
                                            <div class="booking-pathway__advisory-message"
                                                dangerouslySetInnerHTML={{
                                                    __html:advisory_message.innerHTML,
                                                }}
                                            ></div>                
                                        }
                                    </div>
                                </div>
                            </div>
                        </dialog>
                    </>
                }
            </div>            
        </div>
    );
}